module.exports = __webpack_public_path__ + "static/media/location-icon.7df86357.svg";